import { CreateElement, VNode } from 'vue'

import { Button } from '@src/elements/button/button'
import { Input } from '@src/elements/input/input'

export function renderInputs (h: CreateElement): VNode[][] {
  return [
    [
      <Button label={'Default'} />,
      <Button label={'Disabled'} disabled={true} />,
      <Button label={'Elevated'} type={'elevated'} />,
      <Button label={'Outline'} type={'outline'} />,
      <Button label={'Remove'} type={'remove'} />,
      <Button label={'Remove'} type={'remove'} icon={'util/reset-arrow'} />
    ],
    [
      <div></div>
    ],
    [
      <Input placeholder={'Placeholder'} />,
      <Input placeholder={'Placeholder'} label={'Label'} />,
      <Input placeholder={'Placeholder'} icon={'util/search'} />,
      <Input placeholder={'Disabled'} icon={'util/search'} disabled={true} />
    ]
  ]
}
